<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div>
        <div class="businesses">
            <div class="bg-navBox">
                <div class="wrap">
                    <ul>
                        <li v-for="(item, index) in navList" :key="index">
                            <span :class="{ active: index == companySelect }" @click="changeCompany({index})">{{
                                item.title
                            }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="companySelect == 0">
                <div class="content-banner wrap">
                    <div class="logo">
                        <img :src="oneData.logo_fullpath" alt="" />
                    </div>
                    <div class="banner">
                        <div class="title">{{ oneData.title }}</div>
                        <div class="content">
                            <div
                                class="doc"
                                v-html="oneData.explan"
                                style="line-height: 26px"
                            ></div>
                            <!-- <div class="doc">
                                7doc is committed to returning fans and breaking
                                animation boundaries. It is actively working on
                                merchandising to turn the company into a business
                                able to manage the IP in various forms while
                                becoming a new cultural icon and brand of
                                interactive entertainment for all ages.
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="content-navBox wrap">
                    <template v-for="item, key in navList[companySelect].item">
                        <div style="">
                            <span
                                @click="show(key)"
                                :class="key == companyItemSelect ? 'active' : ''"
                                >{{
                                    item ? item.title: ""
                                }}</span
                            >
                        </div>
                        <label v-if="key < navList[companySelect].item.length-1">|</label>
                    </template>
                </div>

                <transition name="fade">
                    <div class="main" v-show="index == 0 && isShow">
                        <ul>
                            <li
                                v-for="(item, index) in this.oneData.item
                                    ? this.oneData.item[0].itemData
                                    : []"
                                :key="index"
                            >
                                <div
                                    v-if="index % 2 == 0"
                                    style="display: flex; width: 100%"
                                >
                                    <div class="wl">
                                        <div class="text">
                                            <div class="title">
                                                {{ item.title }}
                                            </div>
                                            <div
                                                v-html="item.explain"
                                                class="content-explain"
                                                style="color: #3a3a3a"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="wl">
                                        <img :src="item.pic_fullpath" alt="" />
                                    </div>
                                </div>
                                <div v-else style="display: flex; width: 100%">
                                    <div class="wl">
                                        <img :src="item.pic_fullpath" alt="" />
                                    </div>
                                    <div class="wl">
                                        <div class="text">
                                            <div class="title">
                                                {{ item.title }}
                                            </div>
                                            <div
                                                v-html="item.explain"  v-if="index != 1"
                                                class="content-explain"
                                                style="color: #3a3a3a"
                                            ></div>


                                            <el-carousel height="400px" v-if="index==1" :autoplay="false" indicator-position="outside" arrow="never" trigger="click">
                                            <el-carousel-item
                                                v-for="cur in mobileGames"
                                                :key="cur"
                                            >
                                            <div v-html="cur"></div>
                                            </el-carousel-item>
                                        </el-carousel>
                                        </div>
                                    
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-show="index == 1 && isShow">
                        <div class="neko">
                            <div class="banner wrap">
                                <div class="title">
                                    {{
                                        this.oneData.item
                                            ? this.oneData.item[1].itemData[
                                                "Business-itemData-first"
                                            ][0].title
                                            : ""
                                    }}
                                </div>
                                <div class="text">
                                    {{
                                        this.oneData.item
                                            ? this.oneData.item[1].itemData[
                                                "Business-itemData-first"
                                            ][0].explain
                                            : ""
                                    }}
                                </div>
                                <div class="img">
                                    <img
                                        :src="
                                            this.oneData.item
                                                ? this.oneData.item[1].itemData[
                                                    'Business-itemData-first'
                                                ][0].pic_fullpath
                                                : ''
                                        "
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div class="mobile wrap">
                                <div class="title">Mobile Games</div>
                                <!-- <div class="text">
                                    Neko Album the Game is a casual simulation game
                                    aided by storyline narratives. Neko Album the
                                    Game received 9.1 score rating on Taptap
                                    platform, one of the mainstream game
                                    distribution platform in China.
                                </div> -->
                            </div>
                            <!-- <ul class="sweet">
                                <li v-for="(item,index) in this.oneData.item?this.oneData.item[1].itemData['Business-itemData-second']:[]" :key="index">
                                    <img
                                        :src="item.pic_fullpath"
                                        alt=""
                                    />
                                </li>
                            </ul> -->
                            <div class="wrap oneList">
                                <div
                                    v-for="(item, index) in this.oneData.item
                                        ? this.oneData.item[1].itemData[
                                            'Business-itemData-second'
                                        ]
                                        : []"
                                    :key="index"
                                >
                                    <div v-html="item.content"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <!-- <transition name="fade">
                    <div v-show="index == 2 && isShow" class="default">
                        <div class="wrap expected">
                            <div style="padding: 0 100px">
                                <div
                                    v-html="
                                        this.oneData.item
                                            ? this.oneData.item[2].itemData[
                                                'Business-itemData-data'
                                            ][0].content
                                            : ''
                                    "
                                ></div>
                            </div>
                        </div>
                    </div>
                </transition> -->
                
            </div>
            <div v-if="companySelect == 1">
                <div class="content-banner wrap">
                    <div class="logo">
                        <img :src="navList[companySelect].logo_fullpath" alt="" />
                    </div>
                    <div class="banner">
                        <div class="title">{{ navList[companySelect].title }}</div>
                        <div class="content">
                            <div
                                class="doc"
                                v-html="navList[companySelect].explan"
                                style="line-height: 26px"
                            ></div>
                            <!-- <div class="doc">
                                7doc is committed to returning fans and breaking
                                animation boundaries. It is actively working on
                                merchandising to turn the company into a business
                                able to manage the IP in various forms while
                                becoming a new cultural icon and brand of
                                interactive entertainment for all ages.
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="hui-img-list"><!--后续做管理-->
                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/huangyan/w_1.jpg"/>
                    <!-- <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/huangyan/w_2.jpg"/> -->

                    <!-- <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/maoling/w_ml_1.jpg"/> -->
                    <!-- <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/maoling/w_ml_2.jpg"/>
                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/maoling/w_ml_3.jpg"/> -->


                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/qiancongshou/w_qcs_1.jpg"/>
                    <!-- <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/qiancongshou/w_qcs_2.jpg"/>
                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/qiancongshou/w_qcs_3.jpg"/> -->

                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/zhanshouzhiren/w_zszr_1.jpg"/>
                    <!-- <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/zhanshouzhiren/w_zszr_2.jpg"/> -->

                    <img class="huiImgItem" src="https://www-api.multi-metaverse.com:81/uploads/newPic/cat_first.jpg"/>
                    <!-- <div class="hui-img-list-1">
                       <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/VFLbbHFlP0QqmlD1dSxWdKi3keQfmF8TxtJtf7xy.png" style="width:590px; margin-left:5px;"/> 
                       <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/p8q4DehAARzMAtWDNBe06Lk2lPPrca7Ne9tIhi9b.png" style="width:590px; margin-left:5px;"/> 
                    </div>
                    <div class="hui-img-list-1">
                       <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/qyiMLA55SRnpXIvbfcc8COYXaXYA4TG5ladnlkzh.png" style="width:590px; margin-left:5px;"/> 
                       <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/DjKWuMyxiUaiGut3Si9LysXFYHBE1WBS9l8AaiWa.png" style="width:590px; margin-left:5px;"/> 
                    </div>
                    <div class="hui-img-list-2">
                        <div style="float:left; text-align: right; width: 50%;">
                            <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/ZQYSn9xwqSMRhC95lBnoXQbqcOBlS6PVNOwatvhH.png" style="width:500px;"/> 
                        </div>
                        <div style="float:right; text-align: left; width: 50%;">
                            <img src="https://www-api.multi-metaverse.com:81/uploads/20221125/pic/0uDgbZXUIMyTFq6gwNwrUeh9u4Tg8NsfNexw747C.png" style="width: 421px;"/> 
                        </div>
                        <div style="clear:both;"></div>
                    </div> -->
                </div>
                <div>
                    <img class="footlogo" src="https://www-api.multi-metaverse.com:81/uploads/newPic/7doc_log_w.jpg"/>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import navBox from "@/components/navBox/navBox";
import footerBox from "@/components/footerBox/footerBox";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "Businesses",
    components: { footerBox, navBox, mapBox },
    data() {
        return {
            index: 0,
            isShow: true,
            oneData: {},
            types: "",
            fullpathImg: "",
            pathUrl: "",
            loading: false,
            navList: [],
            mobileGames:[],
            companySelect:0,
            companyItemSelect:0,
            companyItemLen:0
        };
    },
    created() {
        this.getWebBusiness();
    },
    methods: {
        getWebBusiness() {
            this.loading = true;
            this.$http.getWebBusiness().then((res) => {
                this.navList = res.companyData;
                this.oneData = res.companyData[0];
                this.mobileGames=res.companyData[0].item[0].itemData[1].explain.split("<hr />");
                this.types = res.bannerData[0].types;
                this.fullpathImg = res.bannerData[0].pic_fullpath;
                this.pathUrl = res.bannerData[0].links;
                this.loading = false;
                this.companySelect = 0;
                this.companyItemSelect = 0;
                // 补充item的宽度
                // for(i=0; i< this.navList.length;i++){
                //     this.navList["itemWidth"] = "18%"
                // }
                // console.log("companyData,", this.navList)
            });
        },
        show(value) {
            //this.index === value? (this.isShow = !this.isShow): (this.isShow = true);
            this.index = value;
            this.companyItemSelect = value
        },
        changeCompany(obj){
            this.companySelect = obj.index
        }
    },
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
    .fade-leave-to
    /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}

.hui-img-list{
    width:1200px;
    height:auto;
    margin: auto;
    .huiImgItem{
        width: 1200px;
        margin: 5px 0px 5px 0px;
    }
}

.footlogo{
    width: 100%;
}

.businesses {
    .bg-navBox {
        height: 55px;
        line-height: 55px;
        background: #fbfbfb;
        border-bottom: 1px solid #f2f2f2;
        ul {
            display: flex;
            li {
                padding-right: 50px;
                font-size: 13px;
                color: #333333;
                span {
                    display: inline-block;
                    height: 53px;
                    line-height: 53px;
                    cursor: pointer;
                }
                .active {
                    border-bottom: 2px solid #283254;
                }
            }
        }
    }
    .content-banner {
        width: 1200px;
        height: 600px;
        background: url("../../assets/businesses/logo_bg.png") no-repeat;
        margin: 40px auto;
        display: flex;
        align-items: center;
        .banner {
            width: 666px;
            height: 371px;
            .title {
                font-size: 36px;
                font-weight: bold;
                color: #ffffff;
                padding-bottom: 23px;
                border-bottom: 1px solid #433b5b;
            }
            .content {
                .doc {
                    margin-top: 40px;
                    color: #ffffff;
                    opacity: 0.6;
                    font-family: "Lucida Bright";
                }
            }
        }
        .logo {
            width: 415px;
            text-align: center;
            flex-grow: 0;
            flex-shrink: 0;
            position: relative;
            top: -60px;
        }
        .logo img{
            width: 168px;
            height: 163px;
        }
    }
    .content-navBox {
        background: #f2f2f2;
        height: 80px;
        line-height: 80px;
        margin-bottom: 50px;
        div {
            font-size: 18px;
            color: #333333;
            width: 49%;
            display: inline-block;
            text-align: center;
        }
        label {
            color: #bfbfbf;
        }
        span {
            cursor: pointer;
        }
        .active {
            border-bottom: 3px solid #0e397f;
            height: 71px;
            line-height: 71px;
            display: inline-block;
        }
    }
    .main {
        width: 100%;
        padding-bottom: 10px;
        font-family: Lucida Bright !important; 
        line-height: 28px !important;
        ul > li {
            display: flex;

            .wl {
                width: 50%;
                flex-grow: 0;
                flex-shrink: 0;
                .text {
                    padding: 15%;
                    .title {
                        color: #161342;
                        font-size: 29px;
                        font-weight: bold;
                        padding-bottom: 40px;
                    }
                }
                .content-explain {
                    font-family: "Lucida Bright";
                    line-height: 28px;
                    /deep/p {
                        line-height: 28px;
                    }
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
    .neko {
        .banner {
            .title {
                font-size: 29px;
                color: #161342;
                margin: 50px 0 30px 0;
            }
            .text {
                font-size: 16px;
                color: #333333;
                margin-bottom: 55px;
                font-family: "Lucida Bright";
            }
            img {
                width: 100%;
                height: 375px;
            }
        }
        .mobile {
            margin-top: 100px;
            .title {
                font-size: 29px;
                color: #161342;
                padding: 30px 0px;
            }
            .text {
                font-size: 16px;
                color: #333333;
                margin-bottom: 55px;
            }
        }
        .oneList {
            // padding-bottom: 10px;
            /deep/p {
                font-family: "Lucida Bright";
            }
        }
        /deep/.sweet {
            width: 1320px;
            margin: 0 auto 180px auto;
            li {
                display: inline-block;
                margin: 0 50px 0 60px;
                img {
                    width: 325px;
                    height: 590px;
                }
            }
        }
    }
    .default {
        margin-bottom: 100px;
        .expected {
            margin: 90px auto;
            color: #333333;
            line-height: 28px;
            font-family: "Lucida Bright";
            /deep/.fl {
                font-size: 24px;
            }
            /deep/.text {
                font-size: 16px;
                font-family: "Lucida Bright";
            }
        }
        .img {
            img {
                width: 100%;
                height: 300px;
            }
        }
    }
    // margin-bottom: 5px;
    // padding-bottom: 10px;
}
.hui-img-list-1{
    width: 100%;
    padding-bottom: 5px;
}
// .hui-img-list-1 img {
//     width: 49.4%;
//     padding-left: 5px;
// }

// .hui-img-list-2{
//     width: 100%;
//     padding-bottom: 5px;
// }
/deep/.el-carousel__button{
    background-color: #a4a4a4;
}
</style>
        